import React, { useState } from 'react';
import { withTranslation } from 'react-i18next';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import Breadcrumbs from '../../../../../components/UI/Breadcrumbs';
import { Button, Card, Collapsible, Input, List, ScannerCode } from '../../../../../components/UI/ComponentsUI';
import InputUI from '../../../../../components/UI/InputUI';
import DeliveryService from '../../../../../services/DeliveryService';
import { isNullOrEmpty, showMessageToastCustom, translate } from '../../../../../utils/util';
import { ENUMS, PERMISSIONS, VISIONS } from '../../../../../utils/constants';
import { checkPermission, getVision } from '../../../../../services/auth';
import LinePickingService from '../../../../../services/LinePickingService';
import { onValueChange } from '../../../../../utils/handleChangeHooks';

const QrCodeCallDelivery = (props) => {
    const manualCallPdu = props.location?.state?.manualCallPdu;
    const manualCallMapping = props.location?.state?.manualCallMapping;

    const [callFilter, setCallFilter] = useState({ pdu: '', partNumber: '', quantity: 1 });
    const [mapping, setMapping] = useState();
    const [visible, setVisible] = useState(false);
    const [ordersDelivery, setOrdersDelivery] = useState([]);
    const [ordersLine, setOrdersLine] = useState([]);

    const getPartNumberMapping = (pdu) => {
        if (!isNullOrEmpty(pdu)) {
            props.getMapping({ pdu: pdu }, (mapping) => {
                if (mapping) {
                    if (getVision() === VISIONS.Fiasa) {
                        props.getOutSide(mapping.partNumber, (response) => {
                            if (response) {
                                if (response.existStock) {
                                    onSearchCall(mapping);
                                } else {
                                    createPartMonitor({
                                        pdu: mapping.pdu,
                                        partNumber: mapping.partNumber,
                                        mappingId: mapping.id,
                                        status: response.status
                                    })
                                }
                            }
                        })
                    } else {
                        onSearchCall(mapping);
                    }
                } else {
                    return showMessageToastCustom(translate('warning', 'general'), `Nenhum desenho encontrado para o PDU ${pdu}`, 3000, 'mdi mdi-alert-circle-outline red-text');
                }
            })
        }
    }

    const getPartNumberPdu = (pdu) => {
        if (!isNullOrEmpty(pdu)) {
            props.getPartNumberPdu(pdu, (response) => {
                const listPartnumberPdu = response?.items;
                if (listPartnumberPdu && listPartnumberPdu.length > 0) {
                    listPartnumberPdu.forEach(element => {
                        props.sendManualCall({ pdu: pdu || '', partNumber: element.partNumber || '', quantity: 1 }, () =>
                            showMessageToastCustom(translate('general.info'), `${translate("delivery:message.qrcode-call-success")} Desenho ${element.partNumber}`, 8000, 'mdi mdi-checkbox-marked-circle-outline green-text')
                        )
                    });
                } else {
                    return showMessageToastCustom(translate('warning', 'general'), `Nenhum desenho encontrado para o PDU ${pdu}`, 3000, 'mdi mdi-alert-circle-outline red-text');
                }

                document.getElementById("pdu").value = ""
            })
        }
    }

    const onSearchCall = (mapping) => {
        callFilter.pdu = mapping.pdu;
        callFilter.partNumber = mapping.partNumber;
        setCallFilter({ ...callFilter })
        setMapping(mapping);
        onSearch({ pdu: mapping.pdu, partNumber: mapping.partNumber, repicking: true })
    }

    const onChange = (event) => {
        onValueChange(event, callFilter, setCallFilter);
    };

    const createPartMonitor = (data) => {
        props.insertRequestOutSide(data, () => {
            return showMessageToastCustom(translate('info', 'general'), "Chamada Monitor Peça fora criado!", 3000, 'mdi mdi-checkbox-marked-circle-outline green-text');
        })
    }

    const onSearch = (filter) => {
        props.getDeliveryCall(filter, (response) => {
            setVisible(true);
            if (response) {
                setOrdersDelivery(response.filter((f) => f.type === ENUMS.eOrderType.Delivery.value));
                setOrdersLine(response.filter((f) => f.type === ENUMS.eOrderType.LinePicking.value))
            }
        })
    };

    const scannerBarCode = (code) => {
        if (manualCallMapping) {
            getPartNumberMapping(code);
        }
        else if (manualCallPdu) {
            getPartNumberPdu(code)
        }

    }

    const addQuantity = () => {
        callFilter.quantity = callFilter.quantity + 1;
        if (callFilter.quantity > mapping?.boxLimit && filterRepicking().length <= 0) {
            callFilter.quantity = mapping?.boxLimit;
        }
        setCallFilter({ ...callFilter });
    };

    const subtractQuantity = () => {
        if (callFilter.quantity - 1 > 0) {
            callFilter.quantity = callFilter.quantity - 1;
            setCallFilter({ ...callFilter });
        }
    };

    const filterRepicking = () => {
        let arrayOrder = [];

        ordersLine.forEach(element => {
            if (element.items) {
                const pendingList = element.items.filter((i) => i.status === ENUMS.eOrderItemStatus.WaitingRepicking.value).length > 0;
                if (pendingList) {
                    arrayOrder.push(element);
                }
            }
        });
        return arrayOrder;
    }

    const filterPicking = () => {
        let arrayOrder = [];

        ordersLine.forEach(element => {
            if (element.items) {
                const pendingList = element.items.filter((i) =>
                    i.status !== ENUMS.eOrderItemStatus.Finished.value
                    && i.status !== ENUMS.eOrderItemStatus.WaitingRepicking.value).length > 0;
                if (pendingList) {
                    arrayOrder.push(element);
                }
            }
        });
        return arrayOrder;
    }


    const filterFinishedDelivery = () => {
        let arrayOrder = [];

        ordersDelivery.forEach(element => {
            if (element.items) {
                const pendingList = element.items.filter((i) => i.status === ENUMS.eOrderItemStatus.Finished.value).length > 0;
                if (pendingList) {
                    arrayOrder.push(element);
                }
            }
        });
        return arrayOrder;
    }

    const filterDelivery = () => {
        let arrayOrder = [];

        ordersDelivery.forEach(element => {
            if (element.items) {
                const pendingList = element.items.filter((i) => i.status !== ENUMS.eOrderItemStatus.Finished.value).length > 0;
                if (pendingList) {
                    arrayOrder.push(element);
                }
            }
        });
        return arrayOrder;
    }


    const onSendCall = () => {
        props.sendManualCall(callFilter, (response) => {
            if (response) {
                showMessageToastCustom(translate('general.info'), translate("delivery:message.manual-call"), 8000, 'mdi mdi-checkbox-marked-circle-outline green-text');
                setVisible(false);
                setCallFilter({ pdu: '', partNumber: '', quantity: 1 })
                setMapping();
            }
        });
    }

    const renderItem = (order) => {
        return (
            order.items ? order.items.map((orderItem) => {
                return <div
                    className="row"
                    key={`${order.orderId}`}
                    style={{ backgroundColor: 'white', color: 'black', padding: '12px', display: 'block', marginBottom: '0px' }}
                >
                    <div className="col s10" style={{ padding: '0px' }}>
                        <div className="col s12" style={{ padding: '0px', fontWeight: 'bold' }}>{`${translate('expedition:picking.orderCode')}: ${order.orderCode}`}</div>
                        <div className="col s12" style={{ padding: '0px' }}>{`CIM: ${orderItem?.cim}`}</div>
                        <div className="col s7" style={{ padding: '0px' }}>{`${translate('line-picking:linepicking.location')}: ${orderItem?.location}`}</div>
                    </div>
                </div>
            }) : <></>
        )
    }

    return (
        <>
            <Breadcrumbs id="idBreadcrumbs" title={{ icon: "mdi mdi-gesture-tap-hold", label: translate('delivery:qrcode-call') }} />
            <div className="container-fluid" style={{ marginTop: '25px', }}>
                <div className="container">
                    <div className="card">
                        <div id="formCallDelivery" className="card-content" style={{ padding: '8px', paddingBlockEnd: '8px' }}>
                            <fieldset className='fieldset'>
                                <div className="input-field no-padding col s12">
                                    <InputUI
                                        required
                                        id='pdu'
                                        name='pdu'
                                        type="text"
                                        label={translate('delivery:fields.pdu')}
                                        onBlur={(evt) => scannerBarCode(evt.target.value)}
                                        defaultValue={""}
                                    />
                                    <ScannerCode onScanner={scannerBarCode} />
                                </div>
                            </fieldset>
                        </div>
                    </div>
                    {
                        mapping &&
                        <Card>
                            <div className='row'>
                                <div className="col s12" style={{ padding: '0px', fontWeight: 'bold' }}>{`${mapping.partNumber} - ${mapping.partNumberDesc || ''}`}</div>
                                <div className="col s12" style={{ padding: '0px', fontWeight: 'bold' }}>{`Limite de Caixas: ${mapping?.boxLimit}`}</div>
                            </div>
                        </Card>
                    }
                </div>
                {
                    visible && <>
                        <Collapsible
                            id="linePicking"
                            close="true"
                            header={`${translate('expedition:picking.order-status.waiting')} ${translate('delivery:general.picking')} ${filterPicking().length}`}
                            body={
                                <div>
                                    {filterPicking().length > 0 &&
                                        <List
                                            data={
                                                filterPicking().map((item) => {
                                                    return renderItem(item);
                                                })
                                            }
                                        />
                                    }
                                </div>
                            }
                        />
                        <Collapsible
                            id="repicking"
                            close="true"
                            header={`${translate(`expedition:${ENUMS.eOrderItemStatus.WaitingRepicking.text}`)} ${filterRepicking().length}`}
                            body={
                                <div>
                                    {filterRepicking().length > 0 &&
                                        <List
                                            data={
                                                filterRepicking().map((item) => {
                                                    return renderItem(item);
                                                })
                                            }
                                        />
                                    }
                                </div>
                            }
                        />
                        {
                            checkPermission(PERMISSIONS.Delivery.Access) && getVision() !== VISIONS.Faasa && getVision() !== VISIONS.FaasaCKD
                            &&
                            <>
                                < Collapsible
                                    id="filterDelivery"
                                    close="true"
                                    header={`${translate('expedition:picking.order-status.waiting')} ${translate('delivery:title')} ${filterDelivery().length}`}
                                    body={
                                        <div>
                                            {filterDelivery().length > 0 &&
                                                <List
                                                    data={
                                                        filterDelivery().map((item) => {
                                                            return renderItem(item);
                                                        })
                                                    }
                                                />
                                            }
                                        </div>
                                    }
                                />
                                < Collapsible
                                    id="filterFinishedDelivery"
                                    close="true"
                                    header={`Delivered ${filterFinishedDelivery().length}`}
                                    body={
                                        <div>
                                            {filterFinishedDelivery().length > 0 &&
                                                <List
                                                    data={
                                                        filterFinishedDelivery().map((item) => {
                                                            return renderItem(item);
                                                        })
                                                    }
                                                />
                                            }
                                        </div>
                                    }
                                />
                            </>
                        }
                        <div className="row" style={{ display: "flex", justifyContent: "center", alignItems: "center" }}>
                            <div className="padding" style={{ textAlign: "center" }}>
                                <i className="mdi mdi-48px mdi-arrow-down-bold" onClick={() => subtractQuantity()} />
                            </div>
                            <div className="padding" style={{ textAlign: "center" }}>
                                <Input
                                    required
                                    id="quantity"
                                    name="quantity"
                                    type="number"
                                    min="0"
                                    step="1"
                                    max={mapping?.boxLimit}
                                    onChange={(evt) => {
                                        if (evt.target.value > mapping?.boxLimit && filterRepicking().length <= 0) {
                                            evt.target.value = mapping?.boxLimit
                                        }
                                        onChange(evt)
                                    }}
                                    value={callFilter.quantity}
                                />
                            </div>
                            <div className="padding" style={{ textAlign: "center" }}>
                                <i className="mdi mdi-48px mdi-arrow-up-bold" onClick={() => addQuantity()} />
                            </div>
                        </div>
                        <div className="row">
                            <Button onClick={() => onSendCall()} full="true" text={translate('delivery:general.send')} />
                        </div>
                    </>
                }
            </div>
        </>
    );
}

const mapStateToProps = (state) => {
    return {
        user: state.userReducer.user,
        justifications: state.justificationReducer.justifications,
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        getMapping: (filter, callback) => {
            dispatch(LinePickingService.getMapping(filter, callback));
        },
        getOutSide: (partNumber, callback) => {
            dispatch(LinePickingService.getOutSide(partNumber, callback));
        },
        getDeliveryCall: (filter, callback) => {
            dispatch(DeliveryService.getDeliveryCall(filter, callback));
        },
        sendManualCall: (filter, callback) => {
            dispatch(DeliveryService.sendManualCall(filter, callback));
        },
        getPartNumberPdu: (filter, callback) => {
            dispatch(DeliveryService.getPartNumberPdu(filter, callback));
        },
        insertRequestOutSide: (data, callback) => {
            dispatch(LinePickingService.insertRequestOutSide(data, callback));
        }
    };
};

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(withTranslation()(QrCodeCallDelivery)));